import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import templateMarkup from 'raw-loader!./addalert-modal.html';
import DataRepository from '../../app/data-framework/data-repository';
import FormatterCommon from '../../app/data-formatters/formatter-common';
import 'knockstrap';
// import 'knockout.validation';
import LoginService from "../../services/login.service";
import DataProvider from "../../app/data-framework/data-provider";


function AlertModal(params) {
    var self = this;
    var editMode = false;

    var CONDITION = {
        STATUS_DOWN:            { name: 'Status is Down', value: 'Status is down' },
        CAPACITY_OVER:          { name: 'License Capacity is Over', value: 'LicenseCapacity over' },
        MEDIA_LOAD_OVER:        { name: 'Media Load is Over', value: 'MediaLoad over' },
        PACKET_LOSS_OVER:       { name: 'Packet loss is Over', value: 'PacketLoss over' },
        QUALITY_BAD:            { name: 'Quality is Bad', value: 'Quality is bad' },
        PARTICIPANT_COUNT:      { name: 'Participant Count is', value: 'ParticipantCount is' },
        MEETING_ACTIVE:         { name: 'Meeting is Active', value: 'Meeting is active' },
        CAMERA_DISCONNECTED:    { name: 'Camera is Disconnected', value: 'Camera is disconnected' },
        DISPLAY_DISCONNECTED:   { name: 'Display is Disconnected', value: 'Display is disconnected' },
        TOUCHPANEL_DISCONNECTED: { name: 'Touch-Panel is Disconnected', value: 'TouchPanel is disconnected' },
        MICROPHONE_DISCONNECTED: { name: 'Microphone is Disconnected', value: 'Microphone is disconnected' },
        CPU_OVER:                { name: 'CPU is Over', value: 'CPU over' },
        TEMPERATURE_OVER:        { name: 'Temperature is Over', value: 'Temperature over' },
        JITTER_OVER:             { name: 'Jitter is Over', value: 'Jitter over' },
        DIAGNOSTIC_ERROR:        { name: 'Cisco Diagnostic Error(s) exist', value: 'Diagnostics errors over' },
        DIAGNOSTIC_WARNING:      { name: 'Cisco Diagnostic Warning(s) exist', value: 'Diagnostics warnings over' },
        TRUNK_PEERS_DOWN:        { name: 'Trunk Contains Down Peer(s)', value: 'Trunk contains down peer(s)' },
        TRUNK_CALL_COUNT_OVER:   { name: 'Call Count is Over', value: 'Trunk call count over' }
    };

    var conditionBridge = [
        CONDITION.STATUS_DOWN,
        CONDITION.CAPACITY_OVER,
        CONDITION.MEDIA_LOAD_OVER,
        CONDITION.PACKET_LOSS_OVER,
        CONDITION.QUALITY_BAD,
        CONDITION.PARTICIPANT_COUNT,
        CONDITION.MEETING_ACTIVE
    ];

    var conditionBridgeCPMM = [
        CONDITION.JITTER_OVER
    ];

    var conditionCallControl = [
        CONDITION.STATUS_DOWN,
        CONDITION.CAPACITY_OVER,
        CONDITION.PACKET_LOSS_OVER,
        CONDITION.QUALITY_BAD
    ];


    var conditionCallControlCPMM = [
        CONDITION.JITTER_OVER
    ];

    var conditionEndpoints = [
        CONDITION.STATUS_DOWN,
        CONDITION.PACKET_LOSS_OVER,
        CONDITION.QUALITY_BAD,
        CONDITION.CAMERA_DISCONNECTED,
        CONDITION.DISPLAY_DISCONNECTED
    ];

    var conditionEndpointsCPMM = [
        CONDITION.TOUCHPANEL_DISCONNECTED,
        CONDITION.MICROPHONE_DISCONNECTED,
        CONDITION.CPU_OVER,
        CONDITION.TEMPERATURE_OVER,
        CONDITION.JITTER_OVER,
        CONDITION.DIAGNOSTIC_ERROR,
        CONDITION.DIAGNOSTIC_WARNING
    ];

    var conditionTrunks = [
      CONDITION.TRUNK_PEERS_DOWN,
      CONDITION.TRUNK_CALL_COUNT_OVER
    ];

    var contitionOtherSystems = [
        CONDITION.STATUS_DOWN
    ];

    // ko.validation.rules.pattern.message = 'Invalid entry';
    //
    // ko.validation.init({
    //     insertMessages: true,
    //     messagesOnModified: true,
    //     messageTemplate: null,
    //     parseInputAttributes: true,
    //     registerExtenders: true
    // }, true);

    self.dataRepository = DataRepository.getInstance();

    initializeNonObservables();
    initializeObservables();
    subscribeObservables();

    initializeOtherDevices();
    initializeBridgeRelatedVariables();
    initializeCallControlRelatedVariables();
    initializeEndpoints();
    initializeTrunks();

    $('#AlertModal').on('show.bs.modal', function () {
        if (!editMode) {
            self.initialize();
        }
        editMode = false;
    });

    setupSelectionModals();

    // UI-1711: There's a lot of duplicated code here, but this runs as soon as the alerts view loads,
    // so we can't check self.showEndpoint or self.showTrunks, and thus we need to manually initialize two modals
    function setupSelectionModals() {
        var idAttr = 'id';
        var optionsText = 'name';
        var availableEndpointsId = ko.observableArray(getLatestEndpointListSnapshot());
        var availableTrunksId = ko.observableArray(getLatestTrunksListSnapshot());
        var selectedEndpointsIdSnapshot;
        var selectedTrunksIdSnapshot;

        //  cf: https://stackoverflow.com/a/27379904
        $('.endpoint-submodal').on('hidden.bs.modal', function() {
            if ($('.endpoint-submodal').hasClass('in')) {
                $('body').addClass('modal-open');
            }
        });
        //  cf: https://stackoverflow.com/a/27379904
        $('.trunks-submodal').on('hidden.bs.modal', function() {
          if ($('.trunks-submodal').hasClass('in')) {
            $('body').addClass('modal-open');
          }
        });

        var endpointWidgetModalEl = $('#EndpointWidgetModal');
        var trunksWidgetModalEl = $('#TrunksWidgetModal');

        //  cf: https://github.com/twbs/bootstrap/issues/3233#issuecomment-6199767
        endpointWidgetModalEl.on('click', '[data-dismiss="modal"]', function(e) {
            e.stopPropagation();
        });
        //  cf: https://github.com/twbs/bootstrap/issues/3233#issuecomment-6199767
        trunksWidgetModalEl.on('click', '[data-dismiss="modal"]', function(e) {
            e.stopPropagation();
        });

        endpointWidgetModalEl.on('show.bs.modal', function() {
            availableEndpointsId(getLatestEndpointListSnapshot());
            selectedEndpointsIdSnapshot = self.selectedEndpoints();
        });
        trunksWidgetModalEl.on('show.bs.modal', function() {
            availableTrunksId(getLatestTrunksListSnapshot());
            selectedTrunksIdSnapshot = self.selectedTrunks();
        });

        self.endpointsSubModalParams = {
            itemPluralName: 'Endpoints',
            optionsText: optionsText,
            optionsValue: idAttr,
            originalAvailableItems: ko.pureComputed(getAvailableItems(availableEndpointsId, self.selectedEndpoints)),
            originalSelectedItems: ko.pureComputed(getSelectedItems(availableEndpointsId, self.selectedEndpoints)),
            updatedAvailableItems: ko.observableArray(),
            updatedSelectedItems: ko.observableArray()
        };
        self.trunksSubModalParams = {
            itemPluralName: 'Trunks',
            optionsText: optionsText,
            optionsValue: idAttr,
            originalAvailableItems: ko.pureComputed(getAvailableItems(availableTrunksId, self.selectedTrunks)),
            originalSelectedItems: ko.pureComputed(getSelectedItems(availableTrunksId, self.selectedTrunks)),
            updatedAvailableItems: ko.observableArray(),
            updatedSelectedItems: ko.observableArray()
        };

        self.discard = function discardChanges() {
          if (self.showEndpoint()) {
            self.selectedEndpoints(selectedEndpointsIdSnapshot);
            endpointWidgetModalEl.click();
          } else if (self.showTrunks()) {
            self.selectedTrunks(selectedTrunksIdSnapshot);
            trunksWidgetModalEl.click();
          }
        };

        self.save = function saveChanges() {
          if (self.showEndpoint()) {
            self.selectedEndpoints(_.map(self.endpointsSubModalParams.updatedSelectedItems(), idAttr));
            endpointWidgetModalEl.click();
          } else if (self.showTrunks()) {
            self.selectedTrunks(_.map(self.trunksSubModalParams.updatedSelectedItems(), idAttr));
            trunksWidgetModalEl.click();
          }
        };

        function getAvailableItems(fullList, selectionIdList) {
            return function getOnlyAvailableItems() {
                return _.differenceBy(ko.unwrap(fullList), _.map(ko.unwrap(selectionIdList), wrapIdWithObjFn), idAttr);
            };
        }

        function getLatestEndpointListSnapshot() {
            return ko.unwrap(self.listOfEndpoints);
        }
        function getLatestTrunksListSnapshot() {
            return ko.unwrap(self.listOfTrunks);
        }

        function getSelectedItems(fullList, selectionIdList) {
            return function getOnlySelectedItems() {
                var itemsDictionary = getIdDictionary(fullList);
                var getElementByIdFn = getElementByIdProvider(itemsDictionary);
                return _.map(ko.unwrap(selectionIdList), getElementByIdFn);
            };

            function getElementByIdProvider(dictionary) {
                var errorMsg = '';
                if (self.showEndpoint()) {
                  errorMsg = 'Invalid Endpoint!';
                } else if (self.showTrunks()) {
                  errorMsg = 'Invalid Trunk!';
                }

                var invalidObj = _.set({}, optionsText, errorMsg);

                return function getElementById(itemId) {
                    var result = _.get(dictionary, [itemId, 0]);
                    if (_.isNil(result)) {
                        result = _.extend({}, invalidObj, _.set({}, idAttr, itemId));
                    }
                    return result;
                };
            }

            function getIdDictionary(observable) {
                return _.groupBy(ko.unwrap(observable), idAttr);
            }
        }

        function wrapIdWithObjFn(id) {
            return _.set({}, idAttr, id);
        }
    }

    self.migrateDeviceTypes = function(alertObj) {
        if (!_.isEmpty(alertObj.deviceTypes)) {
            alertObj.deviceTypes = _.uniq(alertObj.deviceTypes.map(value => {
                switch (value) {
                    case 'VCS Expressway': return 'VCSX';
                    case 'VCS Control': return 'VCS';
                    case 'CTPS - Standalone':
                    case 'CTPS - Conductor Managed': return 'CTPS';
                    default: return value;
                }
            }));
        }
        return alertObj;
    };

    self.enableDisableAlert = function (alertObj) {
        self.dataProvider.logActivity2('togglingAlert', 'Alert Grid', '', alertObj);
        alertObj.enabled = !alertObj.enabled;
        self.setAlertForEdit(alertObj);
        self.saveAlert(true);
        editMode = false;
    };

    // self.errors = ko.validation.group(self);

    self.initialize = function () {
        self.selectedOtherDeviceTypes([]);
        self.selectedBridgeTypes([]);
        self.selectedCallControlTypes([]);
        self.testMessage(null);
        self.sendingEmail(false);
        self.setAlertForEdit({
            conditions: [CONDITION.STATUS_DOWN.value],
            deviceIds: [],
            deviceTypes: [],
            durationSeconds: 300,
            enabled: true,
            format: 'HTML',
            frequency: 'once',
            id: -1,
            name: '',
            recipients: LoginService.userObject.email === 'support@vyopta.com' ? '' : LoginService.userObject.email,
            scheduleDays: [1, 2, 3, 4, 5],
            scheduleEndTime: '23:59',
            scheduleStartTime: '00:00',
            timeZone: self.timezone,
            type: 'Endpoints'
        });
    };

    self.removeAlert = function (alertObj, cb) {
        self.dataProvider.logActivity2('removingAlert', 'Alert Grid', '', alertObj);
        self.dataProvider.getOrgPreferences('vAnalyticsOrgPreferences')
            .then(function (orgPrefs) {
                if (_.isNil(orgPrefs) || !_.has(orgPrefs, 'alertDefs')) {
                    return;
                }
                removeById(orgPrefs.alertDefs, alertObj.id);
                self.dataProvider.saveOrgPreferences('vAnalyticsOrgPreferences', ko.toJS(orgPrefs)).then(function () {
                    cb();
                });
            });
    };

    self.enableSave = ko.pureComputed(function() {
        return  !(self.showCustomText() && self.customText.hasError.required()) && !self.subject.hasError.required();
    });

    self.saveAlert = function (skipvalidation) {
        if (skipvalidation === true || this.enableSave()) {
            var alertObject = getAlertObject();
            self.dataProvider.logActivity2('savingAlert', '', '', alertObject);
            $('#savealert').css('cursor', 'progress');
            setOrgPreferences(alertObject).then(function () {
                $('#savealert').css('cursor', 'default');
                $('#AlertModal').modal('hide');
            });

        } else {
            // self.errors.showAllMessages();
        }
    };

    self.sendTestAlert = function () {
        var numErrors = self.errors().length;
        if (numErrors === 0) {
            var alertObj = getAlertObject();
            self.dataProvider.logActivity2('sendingTestAlert', '', '', alertObj);
            self.testMessage(null);
            self.sendingEmail(true);
            $.post('SampleAlert.aspx', { alertJson: ko.toJSON(alertObj) }, function (data) {
                self.sendingEmail(false);
                self.testMessage(data);
            });

        } else {
            // self.errors.showAllMessages();
        }
    };

    self.setAlertForEdit = function (alertObj) {
        self.migrateDeviceTypes(alertObj);
        // self.errors.showAllMessages(false);

        if (alertObj.id !== -1) {
            self.dataProvider.logActivity2('settingAlertForEdit', '', '', alertObj);
        }

        editMode = true;
        self.currentAlertObject = alertObj.id === -1 ? null : alertObj;

        self.selectedDeviceType(sanitize(alertObj.type));
        setDeviceTypes(sanitize(alertObj.deviceTypes));
        setDeviceIds(sanitize(alertObj.deviceIds));
        setCondition(sanitize(alertObj.conditions[0].toLowerCase()));
        self.duration(sanitize(alertObj.durationSeconds / 60));
        self.subject(alertObj.name);
        self.recipients(alertObj.recipients);
        self.starttime(sanitize(alertObj.scheduleStartTime));
        self.endtime(sanitize(alertObj.scheduleEndTime));

        self.selectedDays(sanitize(alertObj.scheduleDays.map(String)));

        self.selectedFrequency(sanitize(alertObj.frequency));

        self.selectedSentAs(sanitize(alertObj.format));
        self.customText(alertObj.customText);

        self.enabled(sanitize(alertObj.enabled));
    };

    function getAlertObject() {
        var alertObj = self.currentAlertObject ? self.currentAlertObject : {};
        alertObj.type = self.selectedDeviceType();
        alertObj.deviceIds = getDeviceIds();
        alertObj.deviceTypes = getDeviceTypes();
        alertObj.conditions = self.selectedCondition().value;

        var conditionValue = self.selectedCondition().value;

        if ((conditionValue === CONDITION.CAPACITY_OVER.value) ||
            (conditionValue === CONDITION.MEDIA_LOAD_OVER.value)) {
            alertObj.conditions = alertObj.conditions + ' ' + self.selectedPercentage();
        }

        if ((conditionValue === CONDITION.PACKET_LOSS_OVER.value) ||
            (conditionValue === CONDITION.CPU_OVER.value)) {
            alertObj.conditions = alertObj.conditions + ' ' + self.percentValue();
        }

        if ((conditionValue === CONDITION.PARTICIPANT_COUNT.value) ||
            (conditionValue === CONDITION.JITTER_OVER.value) ||
            (conditionValue === CONDITION.TEMPERATURE_OVER.value) ||
            (conditionValue === CONDITION.DIAGNOSTIC_ERROR.value) ||
            (conditionValue === CONDITION.DIAGNOSTIC_WARNING.value) ||
            (conditionValue === CONDITION.TRUNK_CALL_COUNT_OVER.value)) {
            alertObj.conditions = alertObj.conditions + ' ' + self.txtValue();
        }

        alertObj.conditions = [alertObj.conditions];
        alertObj.durationSeconds = self.duration() * 60.0;
        alertObj.name = self.subject();
        alertObj.recipients = self.recipients();
        alertObj.timeZone = self.timezone;
        alertObj.scheduleStartTime = self.starttime();
        alertObj.scheduleEndTime = self.endtime();
        alertObj.scheduleDays = self.selectedDays().map(Number);

        alertObj.frequency = self.selectedFrequency();
        alertObj.severity = '';
        alertObj.format = self.selectedSentAs();
        alertObj.customText = self.customText();
        alertObj.enabled = self.enabled();

        if (!self.currentAlertObject) {
            alertObj.id = new Date().valueOf(); // getNewId();
            alertObj.orgId = LoginService.userObject.orgId;
            alertObj.createdDate = new Date();
            alertObj.createdBy = '#userId'; // will be replaced by save org prefs
            alertObj.createdByName = LoginService.userObject.name;
            alertObj.createdByEmail = LoginService.userObject.email;
        }

        alertObj.modifiedDate = new Date();
        alertObj.modifiedBy = '#userId'; // will be replaced by save org prefs
        alertObj.modifiedByName = LoginService.userObject.name;
        alertObj.modifiedByEmail = LoginService.userObject.email;

        return alertObj;
    }

    function getDeviceIds() {
        if (self.showEndpoint()) {
            return ko.unwrap(self.selectedEndpoints);
        } else if (self.showTrunks()) {
          return ko.unwrap(self.selectedTrunks);
        }
        else {
            return ko.unwrap(self.selectedDevices);
        }
    }

    function getDeviceTypes() {
        if (self.showEndpoint() || self.showTrunks()) {
            return [];
        }
        else {
            return ko.unwrap(self.selectedDeviceTypes);
        }
    }

    function initializeOtherDevices() {
        var otherSystems = self.dataRepository.dictionaryOfNonBridgesNonCallControlsWithIdsObservable;

        self.otherSystemTypes = ko.computed(function() {
            return otherSystems() ? _.keys(otherSystems()) : [];
        });

        setOtherDevices();

        if (_.isEmpty(otherSystems())) {
            var subscription = otherSystems.subscribe(function() {
                setOtherDevices();
                subscription.dispose();
            });
        }

        self.subscriptions.push(self.selectedOtherDeviceTypes.subscribe(function () {
            var selectedIds = setOtherDevices();
            self.selectedOtherDevices(selectedIds);
        }));

        function setOtherDevices() {
            return setSystems(
                otherSystems(),
                self.otherSystemTypes(),
                self.selectedOtherDevices(),
                self.listOfOtherDevices
            );
        }
    }

    function initializeBridgeRelatedVariables() {
        var bridgeDictionaryObservable = self.dataProvider.getDictionaryOfBridgesWithIdsObservable();

        self.bridgeTypes = ko.observableArray(
            bridgeDictionaryObservable() ? _.keys(bridgeDictionaryObservable()) : []
        );

        setBridgeSystems();

        if (_.isEmpty(bridgeDictionaryObservable())) {
            var bridgeSub = bridgeDictionaryObservable.subscribe(function () {
                self.bridgeTypes(_.keys(bridgeDictionaryObservable()));
                setBridgeSystems();
                bridgeSub.dispose();
            });
        }

        self.subscriptions.push(self.selectedBridgeTypes.subscribe(function () {
            var selectedIds = setBridgeSystems();
            self.selectedBridges(selectedIds);
        }));

        function setBridgeSystems() {
            return setSystems(
                bridgeDictionaryObservable(),
                self.bridgeTypes(),
                self.selectedBridgeTypes(),
                self.listOfBridges
            );
        }
    }

    function initializeCallControlRelatedVariables() {
        self.callControlDictionaryObservable = self.dataProvider.getDictionaryOfCallControlsWithIdsObservable();

        self.callControlTypes = ko.observableArray(
            self.callControlDictionaryObservable() ? _.keys(self.callControlDictionaryObservable()) : []
        );

        setCallControlSystems();

        if (_.isEmpty(self.callControlDictionaryObservable())) {
            var ccSub = self.callControlDictionaryObservable.subscribe(function () {
                self.callControlTypes(_.keys(self.callControlDictionaryObservable()));
                setCallControlSystems();
                ccSub.dispose();
            });
        }

        self.subscriptions.push(self.selectedCallControlTypes.subscribe(function () {
            var selectedIds = setCallControlSystems();
            self.selectedCallControls(selectedIds);
        }));

        self.subscriptions.push(self.selectedCallControls.subscribe(function () {
            if (hasSelectedRPADDevices()) {
                console.log('has RPAD devices');
                self.selectedCondition(CONDITION.STATUS_DOWN); // Only condition valid for RPAD devices
            }
        }));

        function setCallControlSystems() {
            return setSystems(
                self.callControlDictionaryObservable(),
                self.callControlTypes(),
                self.selectedCallControlTypes(),
                self.listOfCallControls
            );
        }
    }

    function hasSelectedRPADDevices() {
        var RPADDeviceIDs = _.chain(self.callControlDictionaryObservable()).get('RPAD').map('id').value();
        return !_.isEmpty(_.find(self.selectedCallControls(), function (id) {
            return _.includes(RPADDeviceIDs, id);
        }));
    }

    function initializeEndpoints() {
        self.listOfEndpoints = self.dataProvider.getListOfEndpointsWithIdsObservable();
    }

    function initializeTrunks() {
      self.listOfTrunks = self.dataProvider.getListOfTrunksWithIdsObservable();
    }

    function initializeObservables() {
        if (self.dataProvider.assuranceIsInModules()) {
            conditionEndpoints = _.concat(conditionEndpoints, conditionEndpointsCPMM);
            conditionCallControl = _.concat(conditionCallControl, conditionCallControlCPMM);
            conditionBridge = _.concat(conditionBridge, conditionBridgeCPMM);
        }

        self.conditions = ko.observableArray(conditionEndpoints);
        self.showCustomText = ko.observable(false);
        self.customText = ko.observable('').extend({ required: true });
        self.duration = ko.observable('5');
        self.enabled = ko.observable(true);
        self.endtime = ko.observable('23:59');
        self.frequencyEnabled = ko.observable(true);
        self.listOfOtherDevices = ko.observableArray();
        self.listOfBridges = ko.observableArray();
        self.listOfCallControls = ko.observableArray();
        self.percentValue = ko.observable('2.00');
        self.txtValue = ko.observable(1);
        self.recipients = ko.observable('');
        self.selectedOtherDevices = ko.observableArray();
        self.selectedOtherDeviceTypes = ko.observableArray();
        self.selectedBridges = ko.observableArray();
        self.selectedBridgeTypes = ko.observableArray();
        self.selectedCallControls = ko.observableArray();
        self.selectedCallControlTypes = ko.observableArray();
        self.selectedCondition = ko.observable(_.head(conditionEndpoints));
        self.selectedPercentage = ko.observable('50%');
        self.selectedDays = ko.observableArray(['1', '2', '3', '4', '5']);
        self.selectedDeviceType = ko.observable('Endpoints');
        self.selectedEndpoints = ko.observableArray();
        self.selectedTrunks = ko.observableArray();
        // frequency values: [{ name: 'All Occurrences', value: 'all' }, { name: 'Only Once', value: 'once' }];
        self.selectedFrequency = ko.observable('once');
        self.selectedSentAs = ko.observable('HTML');
        self.sendingEmail = ko.observable(false);
        self.showBridge = ko.observable(false);
        self.showOtherDevices = ko.observable(false);
        self.showCallControl = ko.observable(false);
        self.showTrunks = ko.observable(false);
        self.showPercentageBands = ko.observable(false);
        self.showEndpoint = ko.observable(true);
        self.showTextboxWithPercentageSign = ko.observable(false);
        self.showTextbox = ko.observable(false);
        self.starttime = ko.observable('00:00');
        self.statusText = ko.observable('Enabled');
        self.subject = ko.observable('').extend({ required: true });
        self.testMessage = ko.observable(null);
        self.selectedDevices = ko.observableArray([]);
        self.selectedDeviceTypes = ko.observableArray([]);

        self.showDeviceTypeIdSelectors = ko.pureComputed(function () {
            return self.showBridge() || self.showCallControl() || self.showOtherDevices();
        });

        self.deviceTypes = ko.pureComputed(function () {
            var result;
            if (self.showBridge()) {
                return self.bridgeTypes();
            }
            if (self.showCallControl()) {
                return self.callControlTypes();
            }
            if (self.showOtherDevices()) {
                return self.otherSystemTypes();
            }
            self.selectedDeviceTypes(result); //default to selecting all when the category changes
            return result;
        });

        self.listOfDevices = ko.pureComputed(function () {
            var result;
            if (self.showBridge()) {
                result = ko.unwrap(self.listOfBridges);
            }
            else if (self.showCallControl()) {
                result = ko.unwrap(self.listOfCallControls);
            }
            else {
                result = ko.unwrap(self.listOfOtherDevices);
            }
            self.selectedDevices(result); //when the selected device type changes, we update the list of selected devices to be all devices of that type
            return result;
        });

    }

    function initializeNonObservables() {
        self.percentageBands = ['25%', '50%', '75%', '80%', '85%', '90%', '95%', '100%'];
        self.currentAlertObject = null;
        self.dataProvider = DataProvider.getInstance();
        self.deviceCategories = ['Endpoints', 'Trunk', 'Bridge', 'Call Control', 'Other'];
        self.sentAs = ['HTML', 'Plain Text', 'HTML - Custom'];
        self.subscriptions = [];
        self.timezone = moment.tz.guess();
        self.timezoneAbbr = moment.tz(moment.tz.guess()).zoneAbbr();

        self.multiSelectInitOptions = {
            buttonClass: 'btn btn-primary',
            includeSelectAllOption: true,
            maxHeight: 200,
            nonSelectedText: '(all)',
            numberDisplayed: 1
        };

        self.multiSelectInitOptions1 = {
            buttonClass: 'btn btn-primary',
            includeSelectAllOption: true,
            maxHeight: 200,
            nonSelectedText: 'Type:(all)',
            nSelectedPrefix: 'Type:',
            numberDisplayed: 1
        };

        self.multiSelectInitOptions2 = {
            buttonClass: 'btn btn-primary',
            includeSelectAllOption: true,
            maxHeight: 200,
            nonSelectedText: 'Device: (all)',
            nSelectedPrefix: 'Device: ',
            numberDisplayed: 1
        };
    }

    function removeById(list, id) {
        var ind = null;
        for (var i = 0; i < list.length; i++) {
            if (list[i].id === id) {
                ind = i;
                break;
            }
        }
        if (ind !== null) {
            list.splice(ind, 1);
        }
    }

    function replace(list, alertObj) {
        var ind = null;
        for (var i = 0; i < list.length; i++) {
            if (list[i].id === alertObj.id) {
                ind = i;
                break;
            }
        }
        if (ind !== null) {
            list[ind] = alertObj;
        }
    }

    function setCondition(condition) {
        var condItem = null;

        for (var i = 0; i < self.conditions().length; i++) {
            if (condition.indexOf(self.conditions()[i].value.toLowerCase()) >= 0) {
                condItem = self.conditions()[i];
                break;
            }
        }
        self.selectedCondition(condItem);

        var percTokens = condition.split(' ');
        var val = null;

        if (percTokens.length > 0) {
            val = percTokens[percTokens.length - 1].trim();
        }

        if (val !== null) {
            if (self.showPercentageBands()) {
                self.selectedPercentage(val);
            }
            if (self.showTextboxWithPercentageSign()) {
                self.percentValue(val);
            }
            if (self.showTextbox()) {
                self.txtValue(val);
            }
        }
    }

    function setDeviceIds(deviceIds) {
        if (self.showEndpoint()) {
            self.selectedEndpoints(deviceIds);
        }
        else if (self.showBridge() && deviceIds.length > 0) {
            self.selectedBridges(deviceIds);
        }
        else if (self.showCallControl() && deviceIds.length > 0) {
            self.selectedCallControls(deviceIds);
        }
        else if (self.showTrunks()) {
          self.selectedTrunks(deviceIds);
        }
        else if (self.showOtherDevices()) {
            self.selectedOtherDevices(deviceIds);
        }
        self.selectedDevices(deviceIds);
    }

    function setDeviceTypes(deviceTypes) {
        if (!deviceTypes) {
            deviceTypes = [];
        }
        if (self.showBridge()) {
            self.selectedBridgeTypes(deviceTypes);
        }
        else if (self.showCallControl()) {
            self.selectedCallControlTypes(deviceTypes);
        }
        else if (self.showOtherDevices()) {
            self.selectedOtherDeviceTypes(deviceTypes);
        }
        self.selectedDeviceTypes(deviceTypes);
    }

    function setOrgPreferences(alertObject) {
        return self.dataProvider.getOrgPreferences('vAnalyticsOrgPreferences')
            .then(function (orgPrefs) {
                if (!orgPrefs) {
                    orgPrefs = {};
                }
                if (!orgPrefs.alertDefs) {
                    orgPrefs.alertDefs = [];
                }

                if (!self.currentAlertObject) {
                    orgPrefs.alertDefs.push(alertObject);

                } else {
                    replace(orgPrefs.alertDefs, alertObject);
                }

                return self.dataProvider.saveOrgPreferences('vAnalyticsOrgPreferences', ko.toJS(orgPrefs));
            });
    }

    function subscribeObservables() {
        self.enabled.subscribe(function () {
            self.statusText(self.enabled() ? 'Enabled' : 'Disabled');
        });

        self.selectedDeviceType.subscribe(function (newValue) {
            self.showEndpoint(false);
            self.showBridge(false);
            self.showCallControl(false);
            self.showTrunks(false);
            self.showOtherDevices(false);

            if (newValue === 'Endpoints') {
                self.conditions(conditionEndpoints);
                self.showEndpoint(true);

            } else if (newValue === 'Bridge') {
                self.conditions(conditionBridge);
                self.showBridge(true);

            } else if (newValue === 'Call Control') {
                self.conditions(conditionCallControl);
                self.showCallControl(true);
            } else if (newValue === 'Trunk') {
                self.conditions(conditionTrunks);
                self.showTrunks(true);
            } else {
                self.conditions(contitionOtherSystems);
                self.showOtherDevices(true);
            }
            self.selectedCondition(self.conditions()[0]);
        });

        self.selectedCondition.subscribe(function (newValue) {
            self.showTextbox(false);
            self.showPercentageBands(false);
            self.showTextboxWithPercentageSign(false);
            self.frequencyEnabled(true);

            if (newValue.value === CONDITION.MEDIA_LOAD_OVER.value) {
                self.showPercentageBands(true);
                self.selectedBridgeTypes(['PEXIP']);

            } else if (newValue.value === CONDITION.CAPACITY_OVER.value) {
                self.showPercentageBands(true);

            } else if ((newValue.value === CONDITION.PACKET_LOSS_OVER.value) ||
                (newValue.value === CONDITION.CPU_OVER.value)) {
                self.showTextboxWithPercentageSign(true);

            } else if ((newValue.value === CONDITION.JITTER_OVER.value) ||
                (newValue.value === CONDITION.TEMPERATURE_OVER.value) ||
                (newValue.value === CONDITION.DIAGNOSTIC_ERROR.value) ||
                (newValue.value === CONDITION.DIAGNOSTIC_WARNING.value) ||
                (newValue.value === CONDITION.TRUNK_CALL_COUNT_OVER.value)) {
                self.showTextbox(true);

            } else if (newValue.value === CONDITION.PARTICIPANT_COUNT.value) {
                self.showTextbox(true);
                self.selectedFrequency('once');
                self.frequencyEnabled(false);

            } else if (newValue.value === CONDITION.MEETING_ACTIVE.value) {
                self.selectedFrequency('once');
                self.frequencyEnabled(false);
            }
        });

        self.selectedSentAs.subscribe(function (newType) {
            self.customText('');
            if (newType === 'HTML') {
                self.showCustomText(false);

            } else if (newType === 'Plain Text') {
                self.showCustomText(false);

            } else {
                self.showCustomText(true);
            }

        });

    }
}

function setSystems(dictionary, listOfCategories, selectedCategories, targetObs) {
    var hasCategories = !(_.isNil(selectedCategories) || _.isEmpty(selectedCategories));
    var source = hasCategories ? selectedCategories : listOfCategories;

    var result = [];
    var selectedIds = [];
    source.forEach(function (item) {
        if (dictionary && dictionary[item]) {
            dictionary[item].forEach(function (system) {
                result.push(system);
                selectedIds.push(system.id);
            });
        }
    });
    targetObs(result);

    return selectedIds;
}

function sanitize(item) {

    return FormatterCommon.sanitize(item);
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
AlertModal.prototype.dispose = function () {};

export default { template: templateMarkup, viewModel: AlertModal };
